import React from 'react'

const Statistics = () => {
  return <p>Statistics</p>
}

export default Statistics
